import React, { useState, useEffect, useLayoutEffect } from 'react';
import axios from 'axios';
import {
  TextField,
  Button,
  Input,
  InputLabel,
  FormControl,
  FormHelperText,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
} from '@material-ui/core';
import * as Yup from 'yup';
import { Formik, Field, Form } from 'formik';
import { KeyboardDatePicker } from 'formik-material-ui-pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { parseISO, subDays, format } from 'date-fns';
import BrLocale from 'date-fns/locale/pt-BR';
import { connect } from 'react-redux';
import { fillSelects } from 'store/action/clippings.action';
import api from 'config/api';
import { toast } from 'react-toastify';
import EventIcon from '@material-ui/icons/Event';
import { withStyles } from '@material-ui/core/styles';
import history from 'config/history';
import EditClippingModal from './resume/edit.clipping.modal.compoent';
import oabNumberFormat from '../../../component/masks/oabNumberFormat.component';
import processNumberFormat from '../../../component/masks/processNumberFormat.component';
import ClippingModal from './clippingModal/';
import {
  buildCalendarUrl,
  convertAction,
  modalText,
} from './clippingUtils.component';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DescriptionDate from './descriptionDate.component';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(1),
    margin: '10px',
  },
}));

const defaultState = {
  clippingCross: '',
  processNumber: '',
  object: 6,
  action: 35,
  source: 2,
  court: 1,
  data: '',
  releaseDate: new Date(),
  startDate: new Date(),
  countDate: new Date(),
  endDate: new Date(),
  workDays: 1,
  maxWorkDays: '',
  claimant: '',
  claimantLawyer: '',
  claimantLawyerOAB: '',
  claimed: '',
  claimedLawyer: '',
  claimedLawyerOAB: '',
  observation: '',
  actionSelect: [],
  sourceSelect: [],
  courtSelect: [],
  showClipping: 0,
  scheduled: '',
  dateDisabled: false,
  saveDialog: false,
  errorDialog: false,
  descriptionDialog: false,
  clippingButton: true,
};

const defaultModalValues = {
  processNumber: false,
  source: false,
  court: false,
  startDate: false,
  releaseDate: false,
  endDate: false,
  parties: false,
  claimant: false,
  claimantLawyer: false,
  claimantLawyerOAB: false,
  claimed: false,
  claimedLawyer: false,
  claimedLawyerOAB: false,
};

function Clipping(props) {
  const [currentState, setCurrentState] = useState(defaultState);
  const [pageTitle, setPageTitle] = useState('Novo Recorte');
  const [insertStatus, setInsertStatus] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalValues, setModalValues] = useState(defaultModalValues);
  const [description, setDescription] = useState([]);
  const { location } = useHistory();
  const classes = useStyles();

  useLayoutEffect(() => {
    if (props.teste.history.location.pathname === '/evento/editar') {
      setEditValues(props.teste.history.location.state);
      endDate(
        props.teste.history.location.state.original.work_days,
        new Date(props.teste.history.location.state.original.count_start_date)
      );
    } else {
      endDate(currentState.workDays, currentState.countDate);
    }
    loadPage();
  }, []);

  useEffect(() => {
    if (location && location.state && location.state.clippingCross) {
      setCurrentState(prev => ({
        ...prev,
        clippingCross: location.state.clippingCross,
      }));

      processClipping(location.state.clippingCross);
    }
  }, []);

  function setEditValues(info) {
    setPageTitle('Editar Recorte');
    setCurrentState(prevState => ({
      ...prevState,
      data: info,
      id: info.original.id || '',
      processNumber: info.original.process_number || '',
      object: info.original.object_id || '',
      action: info.original.action_id || '',
      source: info.original.source_id || '',
      court: info.original.court_id || '',
      releaseDate: info.original.release_date || '',
      startDate: info.original.start_date || '',
      countDate: new Date(info.original.count_start_date) || '',
      endDate: info.original.end_date || '',
      workDays: info.original.work_days || 1,
      claimant:
        info.original.parties.filter(party => {
          if (party.party_type_id === 1) return party;
        })[0].name || '',
      claimantLawyer:
        info.original.parties.filter(party => {
          if (party.party_type_id === 3) return party;
        })[0].name || '',
      claimantLawyerOAB:
        info.original.parties.filter(party => {
          if (party.party_type_id === 3) return party;
        })[0].lawyer_oab || '',
      claimed:
        info.original.parties.filter(party => {
          if (party.party_type_id === 2) return party;
        })[0].name || '',
      claimedLawyer:
        info.original.parties.filter(party => {
          if (party.party_type_id === 4) return party;
        })[0].name || '',
      claimedLawyerOAB:
        info.original.parties.filter(party => {
          if (party.party_type_id === 4) return party;
        })[0].lawyer_oab || '',
      observation: info.original.observation || '',
      actionSelect: [],
      sourceSelect: [],
      courtSelect: [],
      going: info.going,
      clippingCross: info.original.clipping || '',
      isDialogOpen: true,
      showClipping: false,
      scheduled: info.original.state || '',
    }));
  }

  const checkData = data => {
    let open = false;
    if (data.parties !== '') {
      Object.keys(data.parties).forEach(function(partie) {
        if (data.parties[partie] === null || data.parties[partie] === '') {
          setModalValues(prevState => ({
            ...prevState,
            [partie]: true,
          }));
          open = true;
        }
      });
    } else {
      setModalValues(prevState => ({
        ...prevState,
        parties: true,
      }));
      open = true;
    }
    Object.keys(data).forEach(function(key) {
      if (data[key] === null || data[key] === '') {
        setCurrentState(prevState => ({
          ...prevState,
          dateDisabled: false,
        }));
        setModalValues(prevState => ({
          ...prevState,
          [key]: true,
        }));
        open = true;
      }
    });

    setOpenModal(open);
  };

  const _closeModal = () => {
    setOpenModal(false);
  };

  function fillData(info) {
    checkData(info);
    setCurrentState(prevState => ({
      ...prevState,
      data: info,
      processNumber: info.processNumber || '',
      action: info.action || 35,
      source: info.source || 2,
      court: info.court || 1,
      releaseDate: info.releaseDate || '',
      startDate: info.startDate || '',
      endDate: info.endDate || '',
      claimant: info.parties.claimant || '',
      claimantLawyer: info.parties.claimantLawyer || '',
      claimantLawyerOAB: info.parties.claimantLawyerOAB || '',
      claimed: info.parties.claimed || '',
      claimedLawyer: info.parties.claimedLawyer || '',
      claimedLawyerOAB: info.parties.claimedLawyerOAB || '',
    }));
  }

  async function deleteEvent(eventId) {
    await axios
      .delete(`/user/events/${eventId}`)
      .then(response => {
        if (response.status === 200) {
          toast.success('Evento apagado com sucesso');
          window.location.href = '/acompanhar-agenda';
        } else if (response.status === 401) {
          toast.error('Evento pertence a outro usuário');
        } else {
          toast.error('Evento não localizado');
        }
      })
      .catch(error => console.log(error));
  }

  function loadPage() {
    fillAction();
    fillSource();
    fillCourt(currentState.source);
  }

  const handleChange = e => {
    const { name, value } = e.target;
    setCurrentState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  async function adaptTimeZone(date) {
    if (!date) {
      date = new Date();
      setCurrentState(prevState => ({
        ...prevState,
        startDate: date,
      }));
    }
    const startDate = new Date(date);
    startDate.setDate(startDate.getDate());
    await addDaysToStartDate(
      startDate,
      currentState.source,
      currentState.court
    );
  }

  async function addDaysToStartDate(count, origem, court) {
    await axios
      .post('/user/events/start-count-date', {
        startDate: count,
        source: origem,
        vara: court,
      })
      .then(response => {
        count = parseISO(response.data.countStartDate);
        setCurrentState(prevState => ({
          ...prevState,
          countDate: count,
        }));
        handleStartCountDateChange(count);
      })
      .catch(error => console.warn(error));
  }

  const fillAction = () => {
    return fillSelects('actions')
      .then(({ data }) => {
        setCurrentState(prevState => ({
          ...prevState,
          actionSelect: data,
        }));
      })
      .catch(e => {
        console.error(e);
      });
  };

  const fillSource = () => {
    return fillSelects('sources')
      .then(({ data }) => {
        setCurrentState(prevState => ({
          ...prevState,
          sourceSelect: data,
        }));
      })
      .catch(e => {
        console.error(e);
      });
  };

  const fillCourt = source => {
    return fillSelects('courts', source)
      .then(({ data }) => {
        setCurrentState(prevState => ({
          ...prevState,
          courtSelect: data,
        }));
      })
      .catch(e => {
        console.error(e);
      });
  };

  const handleChangeSelect = (name, event) => {
    if (event) {
      setCurrentState(prevState => ({
        ...prevState,
        [name]: event.id,
      }));
      if (name === 'source') {
        setCurrentState(prevState => ({
          ...prevState,
          source: event.id,
        }));
        fillCourt(event.id);
      }
    }
  };

  async function endDate(workDays, date, actionId) {
    await axios
      .post('/user/events/end-date', {
        workDays,
        date: subDays(date, 1),
        source: currentState.source,
        vara: currentState.court,
        actionId,
      })
      .then(response => {
        if (actionId) {
          if (
            response.data.action === 'Mera manifestação' ||
            response.data.action === 'Outra Ação' ||
            response.data.action === 'Habeas Corpus' ||
            response.data.action === 'Habeas Data' ||
            response.data.action === 'Protesto nos Autos' ||
            response.data.action === 'Alegações Finais' ||
            response.data.action === 'Intervenção de Terceiros' ||
            response.data.action === 'Oposição aos Autos' ||
            response.data.action === 'Pedido de Revisão' ||
            response.data.action === 'Contrarrazões do Pedido de Revisão' ||
            response.data.action === 'Resposta à Instaração de Dessídio'
          ) {
            setCurrentState(prevState => ({
              ...prevState,
              workDays: '',
              maxWorkDays: '',
            }));
          } else {
            const end = new Date(response.data.endDate);
            setCurrentState(prevState => ({
              ...prevState,
              endDate: end,
              workDays: response.data.daysToAdd,
              maxWorkDays: response.data.daysToAdd,
            }));
          }
        } else {
          setCurrentState(prevState => ({
            ...prevState,
            endDate: new Date(response.data.endDate),
          }));
        }
        setDescription(response.data.daysDescription);
      })
      .catch(error => console.warn(error));
  }

  async function handleActionChange(name, event) {
    if (!event) {
      return;
    }
    setCurrentState(prevState => ({
      ...prevState,
      [name]: event.id,
    }));

    await endDate(0, currentState.countDate, event.id);
  }

  async function handleStartCountDateChange(date) {
    setCurrentState(prevState => ({
      ...prevState,
      countDate: date,
    }));
    await endDate(currentState.workDays, date);
  }

  async function handleWorkDaysChange(name, event) {
    setCurrentState(prevState => ({
      ...prevState,
      [name]: event.target.value,
    }));
    const workDays = event.target.value;
    await endDate(event.target.value, currentState.countDate);
  }

  function handleObservationChange(event) {
    setCurrentState(prevState => ({
      ...prevState,
      observation: event.target.value,
    }));
  }

  async function processClipping(text) {
    let formattedText = text ? text : currentState.clippingCross;
    formattedText = formattedText.replace(/(\r\n|\n|\r)/gm, ' ');
    let status = true;

    if (formattedText.length === 0) {
      return;
    }
    try {
      const { data } = await api.post('/user/clippings/events/', {
        formattedText,
      });

      if (data.error) {
        return handleClickOpen('errorDialog');
      }

      fillData(data);
      Object.entries(data.parties).map(value => {
        if (!value[1]) {
          value[1] = '';
        }
        setCurrentState(prevState => ({
          ...prevState,
          [value[0]]: value[1],
        }));
      });
      fillCourt(currentState.source);
      setCurrentState(prevState => ({
        ...prevState,
        showClipping: 2,
        dateDisabled: true,
      }));
      adaptTimeZone(data.startDate);
    } catch (e) {
      console.warn(e);
      toast.error('Ocorreu um erro ao dividir o recorte.');
      status = false;
    }
    return status;
  }

  function handleClickOpen(name) {
    setCurrentState(prevState => ({
      ...prevState,
      [name]: true,
    }));
  }

  function handleClose(name) {
    setCurrentState(prevState => ({
      ...prevState,
      [name]: false,
    }));
  }

  useEffect(() => {
    if (insertStatus) {
      async function eventInsert(state) {
        try {
          await api.post('/user/events/', state);
          toast.success('Evento criado com sucesso!');
          history.push('/acompanhar-agenda');
        } catch (e) {
          console.warn(e);
          toast.error('Ocorreu um erro ao gravar o evento.');
        }
      }
      const state = { ...currentState };
      delete state.actionSelect;
      delete state.courtSelect;
      delete state.sourceSelect;
      delete state.maxWorkDays;
      delete state.showClipping;
      delete state.parties;
      delete state.dateDisabled;
      delete state.saveDialog;
      delete state.errorDialog;
      delete state.descriptionDialog;
      delete state.clippingButton;
      delete state.data;
      eventInsert(state);
    }
  }, [insertStatus]);

  async function insertEvent(scheduled) {
    await setCurrentState(prevState => ({
      ...prevState,
      scheduled: scheduled,
    }));
    if (currentState.clippingCross === '') {
      await setCurrentState(prevState => ({
        ...prevState,
        clippingCross: 'Sem recorte',
      }));
    }

    setInsertStatus(true);
  }

  async function updateEvent(values) {
    await axios
      .put(`/user/events/`, { values })
      .then(response => {
        if (response.status === 200) {
          toast.success('Evento salvo com sucesso');
        } else if (response.status === 401) {
          toast.error('Evento pertence a outro usuário');
        } else {
          toast.error('Evento não localizado');
        }
      })
      .catch(error => console.log(error));
  }

  function clearForm() {
    setCurrentState(defaultState);
    setModalValues(defaultModalValues);
    loadPage();
  }

  function getAction(action) {
    let actionSelected;
    currentState.actionSelect.map((a, i) => {
      if (a.id === action) {
        actionSelected = a;
      }
    });

    return actionSelected;
  }

  function getSource(source) {
    let sourceSelected;
    currentState.sourceSelect.map((a, i) => {
      if (a.id === source) {
        sourceSelected = a;
      }
    });

    return sourceSelected;
  }

  function getCourt(court) {
    let courtSelected;
    currentState.courtSelect.map((a, i) => {
      if (a.id === court) {
        courtSelected = a;
      }
    });

    return courtSelected;
  }

  const formClipping = Yup.object().shape({
    clippingCross: Yup.string().required('Recorte necessário'),
  });

  const formOthers = Yup.object().shape({
    action: Yup.number().required('Ação necessária'),
    source: Yup.number().required('Origem necessária'),
    court: Yup.number().required('Vara necessária'),
    processNumber: Yup.string()
      .matches(/^[^\s]+$/, true)
      .length(25, true)
      .required(true),
    releaseDate: Yup.string().required('Data de Publicação necessária'),
    startDate: Yup.string().required('Data de Disponibilização necessária'),
    countDate: Yup.string().required('Data de início da contagem necessária'),
    endDate: Yup.string().required('Data de Término necessária'),
    claimant: Yup.string().required('Reclamante necessário'),
    claimantLawyerOAB: Yup.string()
      .nullable()
      .matches(/^[^\s]+$/, true)
      .length(10, true),
    claimed: Yup.string().required('Reclamado necessário'),
    claimedLawyerOAB: Yup.string()
      .nullable()
      .matches(/^[^\s]+$/, true)
      .length(10, true),
    workDays: Yup.number()
      .required('Dias úteis necessário')
      .min(1, 'Dias úteis deve ser maior ou igual a 1')
      .test({
        name: 'max',
        exclusive: true,
        message: `Dias úteis deve ser menor ou igual a ${currentState.maxWorkDays}`,
        test: value =>
          currentState.maxWorkDays === '' || value <= currentState.maxWorkDays,
      }),
  });

  const DarkerDisabledTextField = withStyles({
    root: {
      '& .MuiInputBase-root.Mui-disabled': {
        color: 'rgba(0, 0, 0, 0.5)',
        backgroundColor: '#f7f7f7',
        borderRadius: '6px 6px 6px 6px',
      },
    },
  })(TextField);

  function descriptionButton() {
    return (
      <Button
        variant="contained"
        style={{
          backgroundColor: 'rgba(164,164,164,0.3)',
        }}
        onClick={() => handleClickOpen('descriptionDialog')}
      >
        Descrição do Prazo
      </Button>
    );
  }

  return (
    <MuiPickersUtilsProvider locale={BrLocale} utils={DateFnsUtils}>
      <h3 align="center" style={{ paddingTop: 15, fontWeight: 'bold' }}>
        {pageTitle}
      </h3>

      <Formik
        enableReinitialize={true}
        initialValues={currentState}
        validationSchema={
          currentState.clippingButton ? formClipping : formOthers
        }
      >
        {({
          errors,
          touched,
          values,
          validateForm,
          setTouched,
          setFieldValue,
        }) => (
          <Grid justify="center" container>
            <div style={{ width: 1500 }}>
              <Form>
                <div>
                  <div>
                    {currentState.showClipping === 0 ? (
                      <Paper className={classes.paper}>
                        <TextField
                          name="clippingCross"
                          type="text"
                          label="Cole o recorte aqui"
                          fullWidth
                          multiline
                          rows={10}
                          value={currentState.clippingCross}
                          onChange={handleChange}
                          error={errors.clippingCross && touched.clippingCross}
                          helperText={
                            errors.clippingCross &&
                            touched.clippingCross &&
                            errors.clippingCross
                          }
                        />
                      </Paper>
                    ) : currentState.showClipping === 1 ? (
                      <Paper className={classes.paper}>
                        <DarkerDisabledTextField
                          name="clippingCross"
                          type="text"
                          label="Recorte"
                          fullWidth
                          multiline
                          rows={5}
                          disabled
                          value={currentState.clippingCross}
                        />
                      </Paper>
                    ) : null}
                    <Grid
                      container
                      justify="center"
                      style={{ marginBottom: 10 }}
                    >
                      {currentState.showClipping === 0 ? (
                        <Button
                          name="teste"
                          variant="contained"
                          color="primary"
                          style={{
                            backgroundColor: 'rgb(42,84,40)',
                          }}
                          onClick={() => {
                            setCurrentState(prevState => ({
                              ...prevState,
                              clippingButton: true,
                            }));

                            setTimeout(() => {
                              processClipping();
                              validateForm().then(errors => {
                                if (
                                  !(
                                    Object.entries(errors).length === 0 &&
                                    errors.constructor === Object
                                  )
                                ) {
                                  if (currentState.clippingCross.length === 0) {
                                    setTouched(errors);
                                  }
                                }
                              });
                            }, 300);
                          }}
                        >
                          Processar
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: 'rgba(164,164,164,0.3)',
                          }}
                          onClick={() =>
                            currentState.showClipping === 1
                              ? setCurrentState(prevState => ({
                                  ...prevState,
                                  showClipping: 2,
                                }))
                              : setCurrentState(prevState => ({
                                  ...prevState,
                                  showClipping: 1,
                                }))
                          }
                        >
                          Mostrar/Esconder Recorte
                        </Button>
                      )}
                    </Grid>
                  </div>
                </div>
                <div>
                  <Paper className={classes.paper}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={5}>
                        <TextField
                          fullWidth
                          label="Reclamante"
                          name="claimant"
                          value={currentState.claimant}
                          onChange={handleChange}
                          onBlur={setFieldValue}
                          error={errors.claimant && touched.claimant}
                          helperText={
                            errors.claimant &&
                            touched.claimant &&
                            errors.claimant
                          }
                        />
                      </Grid>
                      <Grid item xs={9} sm={10} md={5}>
                        <TextField
                          fullWidth
                          label="Advogado Reclamante"
                          name="claimantLawyer"
                          value={currentState.claimantLawyer}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={3} sm={2} md={2}>
                        <FormControl fullWidth error={errors.claimantLawyerOAB}>
                          <InputLabel htmlFor="claimantLawyerOAB">
                            Nº. OAB
                          </InputLabel>
                          <Input
                            id="claimantLawyerOAB"
                            inputComponent={oabNumberFormat}
                            name="claimantLawyerOAB"
                            value={currentState.claimantLawyerOAB}
                            onChange={handleChange}
                            error={errors.claimantLawyerOAB}
                          />
                          <FormHelperText error={errors.claimantLawyerOAB}>
                            {errors.claimantLawyerOAB && 'Número OAB inválido'}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={5}>
                        <TextField
                          fullWidth
                          label="Reclamado"
                          name="claimed"
                          value={currentState.claimed}
                          onChange={handleChange}
                          error={errors.claimed && touched.claimed}
                          helperText={
                            errors.claimed && touched.claimed && errors.claimed
                          }
                        />
                      </Grid>
                      <Grid item xs={9} sm={10} md={5}>
                        <TextField
                          fullWidth
                          label="Advogado Reclamado"
                          name="claimedLawyer"
                          value={currentState.claimedLawyer}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={3} sm={2} md={2}>
                        <FormControl fullWidth error={errors.claimedLawyerOAB}>
                          <InputLabel htmlFor="claimedLawyerOAB">
                            Nº. OAB
                          </InputLabel>
                          <Input
                            id="claimedLawyerOAB"
                            inputComponent={oabNumberFormat}
                            name="claimedLawyerOAB"
                            value={currentState.claimedLawyerOAB}
                            onChange={handleChange}
                            error={errors.claimedLawyerOAB}
                          />
                          <FormHelperText error={errors.claimedLawyerOAB}>
                            {errors.claimedLawyerOAB && 'Número OAB inválido'}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Paper>
                  <Paper className={classes.paper}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={5} md={3}>
                        <FormControl fullWidth error={errors.processNumber}>
                          <InputLabel htmlFor="processNumber">
                            Número do Processo
                          </InputLabel>
                          <Input
                            id="processNumber"
                            inputComponent={processNumberFormat}
                            name="processNumber"
                            value={currentState.processNumber}
                            onChange={handleChange}
                            error={errors.processNumber}
                          />
                          <FormHelperText error={errors.processNumber}>
                            {errors.processNumber &&
                              'Número do processo inválido'}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={7} md={4}>
                        <FormControl fullWidth error={errors.source}>
                          <Autocomplete
                            id="source"
                            fullWidth
                            value={getSource(currentState.source) || ''}
                            onChange={(event, newValue) => {
                              handleChangeSelect('source', newValue);
                            }}
                            options={currentState.sourceSelect}
                            getOptionLabel={option => option.source}
                            renderInput={params => (
                              <TextField
                                {...params}
                                label="Origem"
                                variant="outlined"
                              />
                            )}
                            error={errors.action && touched.action}
                          />
                          <FormHelperText error={errors.source}>
                            {errors.source && 'Origem necessária'}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={5}>
                        <FormControl fullWidth error={errors.court}>
                          <Autocomplete
                            id="court"
                            value={getCourt(currentState.court) || ''}
                            onChange={(event, newValue) => {
                              handleChangeSelect('court', newValue);
                            }}
                            options={currentState.courtSelect}
                            getOptionLabel={option => option.court}
                            renderInput={params => (
                              <TextField
                                {...params}
                                label="Vara"
                                variant="outlined"
                              />
                            )}
                            error={errors.court && touched.court}
                          />
                          <FormHelperText error={errors.court}>
                            {errors.court && 'Vara necessária'}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Paper>
                  <Paper className={classes.paper}>
                    <Grid container spacing={1}>
                      <Grid item xs={10} sm={11} md={11}>
                        <FormControl fullWidth error={errors.action}>
                          <Autocomplete
                            id="action"
                            value={getAction(currentState.action) || ''}
                            onChange={(event, newValue) => {
                              handleActionChange('action', newValue);
                            }}
                            options={currentState.actionSelect}
                            getOptionLabel={option => option.action}
                            renderInput={params => (
                              <TextField
                                {...params}
                                label="Prosseguimento necessário"
                                variant="outlined"
                              />
                            )}
                            error={errors.action && touched.action}
                          />
                          <FormHelperText error={errors.action}>
                            {errors.action && 'Ação necessária'}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={2} sm={1} md={1}>
                        <FormControl fullWidth error={errors.workDays}>
                          <InputLabel htmlFor="workDays">Dias úteis</InputLabel>
                          <Input
                            id="workDays"
                            type="number"
                            inputProps={{
                              min: 1,
                              max: currentState.maxWorkDays,
                            }}
                            name="workDays"
                            value={currentState.workDays}
                            onChange={e => {
                              handleWorkDaysChange('workDays', e);
                            }}
                            error={errors.workDays}
                          />
                          <FormHelperText error={errors.workDays}>
                            {errors.workDays}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Paper>
                  <Paper className={classes.paper}>
                    <Grid container spacing={0}>
                      <Grid item xs={5} sm={4} md={2}>
                        <Field
                          component={KeyboardDatePicker}
                          name="releaseDate"
                          label="Data Disponibilização"
                          format="dd/MM/yyyy"
                          value={currentState.releaseDate}
                          onChange={handleChange}
                          error={errors.releaseDate && touched.releaseDate}
                          helperText={errors.releaseDate && touched.releaseDate}
                          disabled={
                            currentState.dateDisabled &&
                            !modalValues.releaseDate
                          }
                        />
                      </Grid>
                      <Grid item xs={2} sm={4} md={1}></Grid>
                      <Grid item xs={5} sm={4} md={2}>
                        <Field
                          component={KeyboardDatePicker}
                          name="startDate"
                          label="Data da Publicação"
                          format="dd/MM/yyyy"
                          value={currentState.startDate}
                          onChange={handleChange}
                          error={errors.startDate && touched.startDate}
                          helperText={errors.startDate && touched.startDate}
                          disabled={
                            currentState.dateDisabled && !modalValues.endDate
                          }
                        />
                      </Grid>
                      <Grid item md={2}></Grid>
                      <Grid item xs={5} sm={4} md={2}>
                        <Field
                          component={KeyboardDatePicker}
                          name="countDate"
                          label="Data de início da contagem"
                          format="dd/MM/yyyy"
                          value={currentState.countDate}
                          onAccept={date => {
                            handleStartCountDateChange(date);
                          }}
                          onChange={handleChange}
                          error={errors.countDate && touched.countDate}
                          helperText={errors.countDate && touched.countDate}
                        />
                      </Grid>
                      <Grid item xs={2} sm={4} md={1}></Grid>
                      <Grid item xs={5} sm={4} md={2}>
                        <Field
                          component={KeyboardDatePicker}
                          name="endDate"
                          label="Data de Término"
                          format="dd/MM/yyyy"
                          value={currentState.endDate}
                          onChange={handleChange}
                          minDate={currentState.countDate}
                          minDateMessage={
                            'Data de término deve ser maior que a data de início da contagem'
                          }
                          error={errors.endDate && touched.endDate}
                          helperText={errors.endDate && touched.endDate}
                          disabled
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                  <Paper className={classes.paper}>
                    <TextField
                      fullWidth
                      label="Descrição das ações específicas (opcional)"
                      multiline={true}
                      rows={6}
                      name="observation"
                      value={currentState.observation}
                      onChange={e => {
                        handleObservationChange(e);
                      }}
                    />
                  </Paper>
                </div>
              </Form>
              {pageTitle !== 'Editar Recorte' ? (
                <div
                  className={'flex-row justify-between'}
                  style={{
                    margin: '5px 10px 0px 10px',
                  }}
                >
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: 'rgba(164,164,164,0.3)',
                    }}
                    onClick={() => clearForm()}
                  >
                    Limpar Campos
                  </Button>
                  {descriptionButton()}
                  <div>
                    <Button
                      onClick={() => {
                        let claimedLawyerOAB = currentState.claimedLawyerOAB;
                        let claimantLawyerOAB = currentState.claimantLawyerOAB;
                        if (claimedLawyerOAB.match(/.+?(?=;)/)) {
                          claimedLawyerOAB = claimedLawyerOAB.match(
                            /.+?(?=;)/
                          )[0];
                        }
                        if (claimantLawyerOAB.match(/.+?(?=;)/)) {
                          claimantLawyerOAB = claimantLawyerOAB.match(
                            /.+?(?=;)/
                          )[0];
                        }

                        setCurrentState(prevState => ({
                          ...prevState,
                          clippingButton: false,
                          claimedLawyerOAB: claimedLawyerOAB,
                          claimantLawyerOAB: claimantLawyerOAB,
                        }));

                        setTimeout(() => {
                          validateForm().then(errors => {
                            if (
                              Object.entries(errors).length === 0 &&
                              errors.constructor === Object
                            ) {
                              handleClickOpen('saveDialog');
                            } else {
                              setTouched(errors);
                            }
                          });
                        }, 300);
                      }}
                      variant="contained"
                      color="primary"
                      id="next-finish-button"
                    >
                      Finalizar
                    </Button>
                    <Dialog
                      open={currentState.saveDialog}
                      onClose={() => handleClose('saveDialog')}
                      aria-labelledby="responsive-dialog-title"
                    >
                      <DialogTitle id="responsive-dialog-title">
                        {'Confirmar dados para gravação'}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText
                          style={{ color: 'rgba(0, 0, 0, 0.87)' }}
                        >
                          Número do processo:
                          {modalText(currentState.processNumber, '')}
                          Data de início de contagem:
                          {modalText(currentState.countDate, '')}
                          Data de término:
                          {modalText(currentState.endDate, '')}
                          Prosseguimento necessário:{' '}
                          {convertAction(
                            currentState.action,
                            currentState.actionSelect
                          )}
                          Dias úteis:
                          {modalText(currentState.workDays, 'dia(s)')}
                        </DialogContentText>
                        <DialogContentText
                          style={{
                            color: 'rgba(0, 0, 0, 0.87)',
                            fontWeight: 'bold',
                            fontSize: 18,
                          }}
                        >
                          Deseja agendar este evento no Juslabore e no Google
                          Calendar?
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={() => {
                            insertEvent('COMPLETED');
                          }}
                          style={{
                            color: 'white',
                            backgroundColor: '#185335',
                          }}
                        >
                          Apenas Juslabore
                        </Button>
                        <Button
                          onClick={() => {
                            const urlRedirect = buildCalendarUrl(currentState);
                            window.open(urlRedirect, '_blank');
                            insertEvent('ACTIVE');
                          }}
                          style={{
                            color: 'white',
                            backgroundColor: 'rgb(49, 97, 207)',
                          }}
                        >
                          Juslabore e Google Calendar
                        </Button>
                      </DialogActions>
                    </Dialog>
                    <Dialog
                      open={currentState.errorDialog}
                      onClose={() => handleClose('errorDialog')}
                      aria-labelledby="responsive-dialog-title"
                    >
                      <DialogTitle id="responsive-dialog-title">
                        {'Erro ao processar o recorte'}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          Não foi possível processar o recorte enviado. Por
                          favor, verifique se o recorte está correto ou preencha
                          os campos manualmente.
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          autoFocus
                          onClick={() => handleClose('errorDialog')}
                          color="primary"
                        >
                          Ok
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </div>
              ) : (
                <div
                  className={'flex-row justify-between'}
                  style={{
                    margin: '5px 10px 0px 10px',
                  }}
                >
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: 'rgba(164,164,164,0.3)',
                    }}
                    onClick={() => {
                      props.history.push('/acompanhar-agenda');
                    }}
                  >
                    Voltar
                  </Button>
                  <EditClippingModal
                    onOkBtn={() => deleteEvent(values.id)}
                  ></EditClippingModal>
                  <Button
                    style={{
                      backgroundColor: 'rgb(1,100,900)',
                      marginRight: 10,
                      color: 'white',
                    }}
                    startIcon={<EventIcon />}
                    onClick={() => {
                      validateForm().then(errors => {
                        if (
                          Object.entries(errors).length === 0 &&
                          errors.constructor === Object
                        ) {
                          if (values.scheduled === 'COMPLETED') {
                            values.scheduled = 'ACTIVE';
                          }
                          updateEvent(values);
                          const urlRedirect = buildCalendarUrl(currentState);
                          window.open(urlRedirect, '_blank');
                        } else {
                          setTouched(errors);
                        }
                      });
                    }}
                  >
                    Google Calendar
                  </Button>
                  {descriptionButton()}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      validateForm().then(errors => {
                        if (
                          Object.entries(errors).length === 0 &&
                          errors.constructor === Object
                        ) {
                          updateEvent(values);
                          props.history.push('/acompanhar-agenda');
                        } else {
                          setTouched(errors);
                        }
                      });
                    }}
                    style={{
                      backgroundColor: 'rgb(42,84,40)',
                    }}
                  >
                    Salvar
                  </Button>
                </div>
              )}
            </div>
            <Dialog
              open={currentState.descriptionDialog}
              onClose={() => handleClose('descriptionDialog')}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogTitle id="responsive-dialog-title">
                {'Descrição do Prazo'}
                <div
                  className="flex-row"
                  style={{
                    fontWeight: 'bold',
                  }}
                >
                  <div
                    className="flex-row justify-center"
                    style={{ width: 35 }}
                  >
                    Dia
                  </div>
                  |
                  <div
                    className="flex-row justify-center"
                    style={{ width: 100 }}
                  >
                    Data
                  </div>
                  |
                  <div
                    className="flex-row justify-center"
                    style={{ width: 150 }}
                  >
                    Descrição
                  </div>
                </div>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <DescriptionDate description={description} />
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  autoFocus
                  onClick={() => handleClose('descriptionDialog')}
                  color="primary"
                >
                  Fechar
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        )}
      </Formik>
      <ClippingModal
        isOpen={openModal}
        modalValues={modalValues}
        closeModal={_closeModal}
      />
    </MuiPickersUtilsProvider>
  );
}

function mapDispatchToProps(dispatch, { history }) {
  return {
    _fillSource: (text, source) => dispatch(fillSelects(text, source)),
    teste: { history },
  };
}

export default connect(mapDispatchToProps)(Clipping);
